import {
  CLEAR_INTERVAL,
  INTERVAL_TIMEOUT,
  SET_INTERVAL,
  timerWorkerScript
} from "./Worker";

const pitchShift = require("pitch-shift");
const pool = require("typedarray-pool");

function PitchShiftNode(context, shiftOffset, options) {
  const queue = [];

  options = options || {};
  options.frameSize = options.frameSize || 512;
  options.hopSize = options.hopSize || options.frameSize / 4;

  const scriptNode = context.createScriptProcessor(options.frameSize, 1, 1);
  scriptNode.shiftOffset = shiftOffset;

  const onTune = () => scriptNode.shiftOffset;

  const onData = data => {
    const buf = pool.mallocFloat32(data.length);
    buf.set(data);
    queue.push(buf);
  };

  const shifter = pitchShift(onData, onTune, options);

  scriptNode.onaudioprocess = function(e) {
    shifter(e.inputBuffer.getChannelData(0));
    const out = e.outputBuffer.getChannelData(0);
    const q = queue.shift();

    out.set(q);
    pool.freeFloat32(q);
  };

  //Enque some garbage to buffer stuff
  shifter(new Float32Array(options.frameSize));
  shifter(new Float32Array(options.frameSize));
  shifter(new Float32Array(options.frameSize));
  shifter(new Float32Array(options.frameSize));
  shifter(new Float32Array(options.frameSize));

  return scriptNode;
}

const audioContext = window.AudioContext || window.webkitAudioContext;

export default class AudioEffect {
  constructor() {
    this._maskFrameTimerWorker = new Worker(timerWorkerScript);
    this._maskFrameTimerWorker.onmessage = this._onMaskFrameTimer;
  }

  _onMaskFrameTimer = response => {
    if (response.data.id === INTERVAL_TIMEOUT) {
      let random = Math.random() < 0.5 ? 1 : 0;

      if (random) {
        random += (Math.random() * 15 + 25) / 100;
      } else {
        random = (Math.random() * 15 + 60) / 100;
      }

      this.shift.shiftOffset = random;
    }
  };

  isEnabled(jitsiLocalTrack) {
    return jitsiLocalTrack.isAudioTrack();
  }

  startEffect = stream => {
    this.context = new audioContext({
      latencyHint: "interactive",
      sampleRate: 44100
    });
    const source = this.context.createMediaStreamSource(stream);
    const dest = this.context.createMediaStreamDestination();

    let random = Math.random() < 0.5 ? 1 : 0;

    if (random) {
      random += (Math.random() * 15 + 25) / 100;
    } else {
      random = (Math.random() * 15 + 70) / 100;
    }

    this.shift = PitchShiftNode(this.context, random);
    source.connect(this.shift);
    this.shift.connect(dest);

    this._maskFrameTimerWorker.postMessage({
      id: SET_INTERVAL,
      timeMs: 30000
    });

    return dest.stream;
  };

  stopEffect = () => {
    this.shift = null;
    this.context = null;

    this._maskFrameTimerWorker.postMessage({
      id: CLEAR_INTERVAL
    });
  };
}
